var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldLikeDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.09 14.87H9.76c-.15 0-.3-.06-.39-.18a.562.562 0 0 1-.12-.44l.29-1.86c.12-.55-.25-1.18-.8-1.37-.52-.19-1.12.07-1.37.44L5.06 14.9v-.43c0-.84-.36-1.18-1.24-1.18h-.58c-.88.01-1.24.35-1.24 1.19v5.71c0 .84.36 1.18 1.24 1.18h.58c.84 0 1.19-.33 1.22-1.09l1.75 1.35c.25.24.78.37 1.16.37h2.21c.76 0 1.52-.57 1.7-1.27l1.4-4.25c.15-.41.11-.8-.11-1.11-.22-.32-.61-.5-1.06-.5zM20.53 2.61c-.84 0-1.19.33-1.23 1.09l-1.75-1.35c-.24-.24-.78-.37-1.16-.37h-2.21c-.76 0-1.52.57-1.7 1.27l-1.4 4.25c-.15.41-.1.8.11 1.11.22.32.61.5 1.06.5h2.33c.15 0 .3.06.39.18.1.12.14.27.12.44l-.29 1.86c-.12.55.25 1.18.8 1.37.52.19 1.12-.07 1.37-.44l2.31-3.44v.43c0 .84.36 1.18 1.24 1.18h.58c.88 0 1.24-.34 1.24-1.18V3.78c.01-.83-.35-1.17-1.23-1.17h-.58z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldLikeDislike);
export default __webpack_public_path__ + "static/media/vuesax-bold-like-dislike.1240fb8827bb4c50850c5f089e84a4e8.svg";
export { ForwardRef as ReactComponent };